import { Button, Container, Row } from 'darrius';

import styles from './ProfileBackButton.module.scss';

export function ProfileBackButton() {
  function handleBackButton() {
    history.back();
  }

  return (
    <>
      <Button.Root
        variation="clear"
        className={`${styles['button']} button__back`}
        onClick={handleBackButton}
        size="small"
      >
        <img
          src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/instant-match-back-arrow.svg`}
          alt="Seta para volta ao passo anterior"
          width={16}
          height={16}
        />
        Voltar para lista
      </Button.Root>
    </>
  );
}
